"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClipEssenceProperty = exports.clipEssencePropertyDefinition = void 0;
exports.clipEssencePropertyDefinition = {
    view: {
        label: 'Clip essence',
        readonly: true,
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'providers',
            argument: ['Mediabase Delivery Agent'],
        },
    ],
    type: 'service',
    multiple: false,
    name: 'clip-essence',
};
const isClipEssenceProperty = (prop) => {
    return prop.name === exports.clipEssencePropertyDefinition.name;
};
exports.isClipEssenceProperty = isClipEssenceProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xpcC1lc3NlbmNlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY2xpcC1lc3NlbmNlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGNBQWM7UUFDckIsUUFBUSxFQUFFLElBQUk7S0FDZjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLENBQUMsMEJBQTBCLENBQUM7U0FDdkM7S0FDRjtJQUNELElBQUksRUFBRSxTQUFTO0lBQ2YsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsY0FBYztDQUNXLENBQUE7QUFJMUIsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLElBQWtCLEVBQStCLEVBQUU7SUFDdkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFDQUE2QixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakMifQ==